<template>
  <div>
    <h2 v-if="panelData.length > 0"> {{ title }} </h2>

    <CopyTrackWrapper
      :type="title"
      :title="datum.title"
      class="panel panel-default"
      v-for="(datum, index) in panelData"
      :key="index"
    >
      <div class="panel-heading">
        <h3 class="panel-title" v-html="datum.title"/>
      </div>
      <div class="panel-body">
        <WikiText
          :text="datum.text"
          :lock-mode="lockMode"
          :locked="shouldBlur || shouldBlockLink"/>
      </div>
    </CopyTrackWrapper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  ACTION_TYPES,
  CONTENT_TYPES,
  actionPermissions,
  blurContentPermissions
} from '@/util/access_visibility'
import WikiText from '@/components/WikiText'
import CopyTrackWrapper from '@/components/CopyTrackWrapper'

export default {
  name: 'StrategyPanels',
  components: {
    WikiText,
    CopyTrackWrapper
  },
  props: {
    title: {
      type: String,
      required: true
    },
    panelData: {
      type: Array,
      required: true
    },
    overwriteBlur: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  computed: {
    ...mapGetters('user', ['authInfo']),
    shouldBlur() {
      let modifiedAuthInfo = Object.assign(
        {
          overwriteBlur: this.overwriteBlur
        },
        this.authInfo
      )
      return blurContentPermissions(CONTENT_TYPES.STRATEGY, {}, modifiedAuthInfo).blur
    },
    shouldBlockLink() {
      return actionPermissions(ACTION_TYPES.FOLLOW_LINK, CONTENT_TYPES.STRATEGY, {}, this.authInfo)
        .block
    },
    lockMode() {
      if (this.shouldBlur) {
        return 'completely_blur'
      } else if (this.shouldBlockLink) {
        return 'lock_links'
      }
      return 'default'
    }
  }
}
</script>

<style scoped>
h2 {
  font-weight: bold;
}

.panel-heading {
  font-size: 16px;
  padding: 10px 24px;
}

.panel-title {
  font-weight: bold;
}

.panel-body {
  font-size: 16px;
  font-weight: 300;
  line-height: 25px;
  padding: 16px 24px;
}
</style>
